// Maps contract custom errors / wallet errors to friendly messages for toasts.

const FRIENDLY = {
  AlreadyRegistered: "This wallet is already registered.",
  NotRegistered: "This wallet is not registered yet.",
  InvalidPackage: "Invalid package selected.",
  AlreadyActive: "You already own this package.",
  PreviousNotActive: "Activate the previous package first.",
  TransferFailed: "USDT transfer failed. Check your balance and approval.",
  UserNotActive: "This package is not active for your account.",
  NoIncomeToClaim: "No income available to claim.",
  NoSCNToClaim: "You have no SCN to claim right now.",
  AmountMustBePositive: "Amount must be greater than zero.",
  ZeroAddress: "Invalid address.",
  ContractPaused: "The contract is currently paused. Please try again later.",
  Reentrancy: "Transaction blocked. Please retry.",
  InsufficientAllowance: "Approval needed before this action.",
  InsufficientBalance: "Insufficient balance.",
};

export function parseError(err) {
  if (!err) return "Something went wrong.";

  // User rejected in wallet
  const code = err.code;
  if (code === 4001 || code === "ACTION_REJECTED") {
    return "Transaction rejected in wallet.";
  }
  if (code === "INSUFFICIENT_FUNDS") {
    return "Not enough BNB for gas.";
  }

  // Try to surface a known custom error name from the revert data/message
  const haystack = [
    err.reason,
    err.errorName,
    err?.error?.message,
    err?.data?.message,
    err?.message,
  ]
    .filter(Boolean)
    .join(" ");

  for (const key of Object.keys(FRIENDLY)) {
    if (haystack.includes(key)) return FRIENDLY[key];
  }

  if (/user (denied|rejected)/i.test(haystack)) return "Transaction rejected in wallet.";
  if (/insufficient funds/i.test(haystack)) return "Not enough BNB for gas.";

  // Fallback: short, readable
  if (err.reason) return err.reason;
  if (err.message) return err.message.split("(")[0].slice(0, 140);
  return "Transaction failed.";
}
